import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setDriverBatchState } from 'store/insuranceAnketa/actions';
import { DRIVER_FIELDS } from 'store/insuranceAnketa/constants';
import { selectDriver } from 'store/insuranceAnketa/selectors';

export const useEdit = ({ id }) => {
  const dispatch = useDispatch();

  const { [DRIVER_FIELDS.EDIT]: editing } = useSelector(selectDriver(id));

  const onSetEdit = useCallback(
    (edit) => {
      dispatch(setDriverBatchState({ id, values: { [DRIVER_FIELDS.EDIT]: edit } }));
    },
    [id]
  );

  return { editing, onSetEdit };
};
